/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicCompanyResource } from '../models/PublicCompanyResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicAccessService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Diagnostic de la liaison avec Lola
     * Sans token : verifie que le serveur Lola de l'entreprise (`Company-Key`) est joignable, puis qu'une requete simple aboutit. Reponse : `{ company, port: { host, port, success, message }, database: { success, message } }`. Sert a la page d'installation.
     * @returns any
     * @throws ApiError
     */
    public publicAccessLolaCheck(): CancelablePromise<{
        company: PublicCompanyResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/access/lola-check',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Etat de la connexion Prodevis
     * Sans token : l'entreprise, si une connexion Prodevis est configuree (`has_credentials`), le serveur (`host`) et, le cas echeant, les parametres visibles (sans mot de passe).
     * @returns any
     * @throws ApiError
     */
    public publicAccessGetInfo(): CancelablePromise<{
        company: PublicCompanyResource;
        has_credentials: string;
        host: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/access/info',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Enregistrer et tester la connexion Prodevis
     * Premiere configuration uniquement : refuse (400) si une connexion existe deja (utiliser `access/test`) ou si le serveur n'est pas renseigne. Enregistre les identifiants puis tente une connexion. Reponse : `{ success, message }`.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public publicAccessSaveAndTest(
        requestBody: {
            port?: number | null;
            base: string;
            login: string;
            password: string;
        },
    ): CancelablePromise<({
        success: boolean;
        message: string;
    } | {
        success: boolean;
        message: string;
        credentials: string;
    })> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/access/save-and-test',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Tester la connexion Prodevis
     * Reponse : `{ success, message }`. 400 si aucune connexion n'est configuree.
     * @returns string
     * @throws ApiError
     */
    public publicAccessTest(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/access/test',
            errors: {
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
